import { useState, useEffect } from "react";
import { useAuth } from "../auth";
import { useAppSelector } from "../../../redux/hooks";
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import CloudConectivity from './components/CloudConectivity';
import '../ctr-r/CTXRegister/ha/estiloscard.css';

function Edgecruds() {
  const { currentUser } = useAuth();
  const ListaPermisosTenant = useAppSelector((state: { ListPermissionSlice: { Permissions: any; }; }) => state.ListPermissionSlice.Permissions);
  const [flag, setflag] = useState<number>();
  const [num, setnum] = useState<number>();

  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('CTXR.List')) {
      setflag(1);
    }
  }, [currentUser]);

  return (
    <div className='card'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='f-titulo text-marino fs-md'>Cloud Connectivity</span>
        </h3>
        <div className='row'>
          <div className='col-auto'>
            <i className="b bi-check2-circle text-azul" style={{ fontSize: '24px' }}></i> <strong>UP</strong>
          </div>
          <div className='col-auto'>
            <i className="b bi-arrow-down-circle" style={{ fontSize: '24px', color: '#FF4089' }}></i> <strong>DOWN</strong>
          </div>
          <div className='col-auto'>
            <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '24px' }}></i> <strong>WARNING</strong>
          </div>
          <div className='col-auto'>
            <i className="b bi-clock-history" style={{ fontSize: '24px', color: '#02C8C1' ,marginRight: '2px'}}></i>
            <strong>SHOW HISTORY</strong>
          </div>
          {/* Aquí agregamos los iconos del maintenance_mode */}
          <div className='col-auto'>
            <i className="b bi-tools" style={{ fontSize: '24px', color: '#28a745', marginRight: '2px' }}></i><strong>ON</strong>
            <i className="b bi-tools" style={{ fontSize: '24px', color: '#FF4089', marginLeft: '2px' }}></i> <strong>OFF</strong>
          </div>
        </div>
      </div>
      <div style={{ marginLeft: '25px', marginRight: '25px' }} className="tab-content" id="myTabContent">
        <Routes>
          {(currentUser?.ListPermiso?.includes('CTXR.List') || !ListaPermisosTenant.includes('CTXR.List')) && (
            <Route path="connection" element={<CloudConectivity />} />
          )}
          {/* Default route */}
          <Route path="*" element={<Navigate to="connection" />} />
        </Routes>
      </div>
    </div>
  );
}

export default Edgecruds;
